import { Component, HostBinding, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { NavigationStart, Router } from '@angular/router';
import { PortalBanner } from '../../models/portal-banner.interface';
import { ClaimService } from 'src/app/services/claim.service';
import { LoginService } from 'src/app/services/login.service';
@Component({
  selector: 'upsc-tupss-layout',
  templateUrl: './tupss-layout.component.html',
  styleUrls: ['./tupss-layout.component.scss']
})
export class TupssLayoutComponent implements OnInit {
  @HostBinding('class') public hostClass = 'tupss-layout';
  isAdjuster: boolean;
  currentUrl: string;
  showInsureshieldFooter: boolean = false;
  showONLFooter: boolean = false;
  pirateShipFlow;

  isDynamicOutage: boolean = false;
  portalBanner: PortalBanner | null = null;
  policies: any = {};
  countryLocale: string = 'en';
  flowType: string = '';
  portalType: string = '';
  partnerName: string = '';
  userDetails: any = {};

  constructor(private userService: UserService,
    private router: Router,
    private claimService: ClaimService,
    private loginService: LoginService) { }

  public ngOnInit(): void {
    this.isAdjuster = this.userService.isUserAdjuster();
    this.currentUrl = this.router.url;

    // not 100% sure which mychoice pages they want the insureshield footer for
    if (this.currentUrl && this.currentUrl.includes('ups-my-choice')) {
      this.showInsureshieldFooter = true;
      this.showONLFooter = false;
    } else {
      this.showInsureshieldFooter = false;
      this.showONLFooter = true;
    }

    this.pirateShipFlow = this.router.url.includes('pirate-ship');
    this.getBanner();
  }

  private setBannerVisibility(): void {

    if (!this.portalBanner) {
      this.isDynamicOutage = false;
      return;
    }

    const now = new Date();
    const startTime = new Date(this.portalBanner.startTime);
    const endTime = new Date(this.portalBanner.endTime);

    this.isDynamicOutage =
      now >= startTime &&
      now <= endTime;
  }

  private resolveBannerContext(): void {
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails') || 'null') || {};
    this.flowType = sessionStorage.getItem('flowType') || '';
    this.portalType = this.userDetails?.type?.trim() || '';
    this.partnerName = '';

    const segments = this.router.parseUrl(this.router.url).root.children['primary']?.segments || [];
    const portal = segments.map(segment => segment.path).find(path =>
      ['tccp', 'tfcp', 'unishippers', 'ajg', 'inxpress', 'guest', 'pirate-ship'].includes(path));

    if (portal === 'tccp' || portal === 'tfcp') {
      this.portalType = portal;
      this.flowType = portal;
    } else if (portal) {
      this.portalType = 'customized-claims-portal';
      this.flowType = portal === 'unishippers' ? 'customized-claims-portal'
        : portal === 'pirate-ship' ? 'pirateship'
          : portal === 'guest' ? 'ajg' : portal;
    }
  }

  getBanner() {
    this.resolveBannerContext();

    // Skip banner API call for Pirate Ship as it has existing banner logic
    if (this.flowType === 'pirateship') {
      this.isDynamicOutage = false;
      return;
    }

    const bannerDismissed = sessionStorage.getItem('portalBannerDismissed');
    if (bannerDismissed === 'true') {
      this.isDynamicOutage = false;
      return;
    }

    const cachedBanner = sessionStorage.getItem('portalBanner');

    if (cachedBanner) {
      this.portalBanner = JSON.parse(cachedBanner);
      this.setBannerVisibility();
      return;
    }

    if (this.portalType === 'customized-claims-portal') {
      this.portalType = 'CCP';
      this.partnerName = this.flowType === 'customized-claims-portal' ? 'unishippers'
        : this.flowType === 'pirateship'
          ? 'pirate-ship' : this.flowType;
    }

    const policyNumber = this.loginService.getPolicyDetails()?.policyNumber!;
    this.claimService
      .getPolicyBanners(this.portalType, policyNumber, this.partnerName, this.countryLocale)
      .subscribe(response => {

        const banner = response?.data?.portalBanners?.[0];

        if (banner) {

          this.portalBanner = {
            messageText: banner.messageText,
            startTime: banner.startTime,
            endTime: banner.endTime
          };

          sessionStorage.setItem(
            'portalBanner',
            JSON.stringify(this.portalBanner)
          );

          this.setBannerVisibility();
        } else {
          this.isDynamicOutage = false;
        }
      });
  }

  onBannerClosed(): void {
    this.isDynamicOutage = false;
    sessionStorage.setItem('portalBannerDismissed', 'true');
  }

}

